import loadSubscribeToProduct from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/ProductSubscribe";
import loadProductSubscriptionStatus from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/ProductSubscriptionStatus";
import loadUnsubscribeToProduct from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/ProductUnsubscribe";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import isNumber from "lodash/isNumber";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentUserIsGuest: getCurrentUserIsGuest(state),
    userName: state.context.session.userName,
});

const mapDispatchToProps = {
    loadProductSubscriptionStatus,
    loadUnsubscribeToProduct,
    loadSubscribeToProduct,
};

type Props = ReturnType<typeof mapStateToProps> & HasProductContext & ResolveThunks<typeof mapDispatchToProps>;

const subscribeWrapperStyles: InjectableCss = {
    css: css`
        text-align: center;
        margin-top: 30px;
    `,
};

const subscribeStyles: InjectableCss = {
    css: css`
        background: #0072bc;
        border: 1px solid #0072bc;
        color: white;
        border-radius: 7px;
        font-size: 10px;
        padding: 0 15px;
        min-height: 30px;
    `,
};

const unsubscribeStyles: InjectableCss = {
    css: css`
        background: white;
        border: 1px solid #0072bc;
        color: #0072bc;
        border-radius: 7px;
        font-size: 10px;
        padding: 0 15px;
        min-height: 30px;
    `,
};
const ProductSubscriptionWidget = ({
    productContext,
    loadUnsubscribeToProduct,
    loadSubscribeToProduct,
    loadProductSubscriptionStatus,
    userName,
    currentUserIsGuest,
}: Props) => {
    const productErpNumber = productContext.product.productNumber;
    const productQuantity = productContext.productInfo?.inventory?.qtyOnHand;
    const trackInventory = productContext.product.trackInventory;
    const showProductSubscribeButtons =
        isNumber(productQuantity) && productQuantity <= 0 && userName && !currentUserIsGuest && trackInventory;
    const [subscribed, setSubscribed] = useState(false);

    useEffect(() => {
        if (productErpNumber) {
            loadProductSubscriptionStatus({
                productErpNumber,
                onSuccess: result => {
                    if(result && result.length > 0) {
                        setSubscribed(true);
                    }
                },
                onError: () => {},
            });
        }
    }, [productErpNumber]); // Only run when productErpNumber changes

    // Handler to subscribe the product
    const handleSubscribe = () => {
        loadSubscribeToProduct({
            productErpNumber,
            onSuccess: result => {
                if (result?.Success) {
                    setSubscribed(true);
                }
            },
            onError: () => {},
        });
    };

    // Handler to unsubscribe the product
    const handleUnsubscribe = () => {
        loadUnsubscribeToProduct({
            productErpNumber,
            onSuccess: result => {
                setSubscribed(false);
            },
            onError: () => {},
        });
    };

    return (
        <>
            {showProductSubscribeButtons ? (
                <StyledWrapper data-test-selector="productDetailsSubscribeUnsubscribeBlock" {...subscribeWrapperStyles}>
                    {!subscribed ? (
                        <Button data-test-selector="btnSubscribe" onClick={handleSubscribe} {...subscribeStyles}>
                            {translate("Subscribe")}
                        </Button>
                    ) : (
                        <Button data-test-selector="btnUnsubscribe" onClick={handleUnsubscribe} {...unsubscribeStyles}>
                            {translate("Unsubscribe")}
                        </Button>
                    )}
                </StyledWrapper>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductSubscriptionWidget)),
    definition: {
        displayName: "Product Subscription",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
